import Swiper from "swiper";
import "../vendor/circle-player";

jQuery(document).ready(function($) {
  const slideSelector = ".album-player";
  const $slides = $(slideSelector);
  const $titleContainer = $("#js-album-title");
  const $container = $(".js-track-slider");

  function albumSlider() {
    const slideSelector = ".album-player";
    const $slides = $(slideSelector);
    const $container = $(".js-album-slider");
    const $slideItems = $container.find(".swiper-slide");

    $container.each(function() {
      const $this = $(this);
      const $items = $this.find(".swiper-slide");

      const settings = {
        loop: true,
        centeredSlides: true,
        slidesPerView: "auto",
        navigation: {
          nextEl: ".js-album-slider-next",
          prevEl: ".js-album-slider-prev"
        },
        preventClicks: false,
        preventClicksPropagation: false,
        spaceBetween: 10,
        effect: "coverflow",
        coverflowEffect: {
          rotate: 30,
          stretch: 0,
          depth: 200,
          modifier: 1,
          slideShadows: true
        }
      };

      if ($items.length > 1) {
        new Swiper($this[0], settings);
      }
    });
  }

  albumSlider();

  $container.each(function() {
    const $this = $(this);

    const settings = {
      centeredSlides: true,
      slidesPerView: "auto",
      navigation: {
        nextEl: ".js-slider-next",
        prevEl: ".js-slider-prev"
      },
      preventClicks: false,
      preventClicksPropagation: false,
      spaceBetween: 40
    };

    const playerSlider = new Swiper($this[0], settings);
    var $nodes = $this.find(".js-circle-player");
    var players = [];

    playerSlider.on("slideChange", function(args) {
      const index = playerSlider.realIndex;
      const title = $slides.eq(index).attr("data-post-title");
      $titleContainer.text(title);
      playByIndex(index);
    });

    const playByIndex = function(idx) {
      // Pause all
      players.forEach(function(player) {
        player.pause();
      });

      // Play the one we want
      players[idx].play();
    };

    $nodes.each(function(idx) {
      const $this = $(this);

      $this.on("click", function(evt) {
        players.forEach(function(player) {
          if (player.element !== evt.currentTarget) {
            player.pause();
          }
        });

        const clickedPlayer = players[idx];

        if (clickedPlayer.playing) {
          clickedPlayer.pause();
        } else {
          clickedPlayer.play();
        }
      });

      var $link = $this.find(".js-audio-file");
      var audioUrl = $link.attr("href");
      // now init one as an example
      var cap = new CircleAudioPlayer({
        element: $this[0],
        audio: audioUrl || "#",
        size: $this.outerWidth(),
        borderWidth: 12,
        borderColor: "transparent",
        playedColor: "#E8262D",
        backgroundColor: "transparent"
      });
      players.push(cap);
    });


  });
});
